goog.provide('el8.util.amplitude.collaborativePracticeHelpers');

goog.require('el8.util.amplitude.helpers');


var comparingProfilesSectionsMap = {'allergies': 'Allergies',
        'intols':'Drug Intolerances', 'problems': 'Problem List',
        'history': 'History', 'perm-rx': 'Permanent Rx Meds',
        'perm-otc': 'Permanent OTC Meds', 'vaccines': 'Vaccines'};

var CARE_TEAM_ACTIONS = Object.freeze({
    addToCareTeam: "Add provider to care team",
    addToProfile: "Add to Profile",
    deleteFromChart: "Delete from Patient's Chart",
    discardAdd: "Discard",
    exportNote: "Export Care to Note",
    grantAccess: "Grant access to shared records",
    leaveCareTeam: "Leave Care Team",
    markAsPCP: "Mark as Patient's PCP",
    removeAsPCP: "Remove as Patient's PCP",
    removeFromCareTeam: "Remove from Care Team",
    shareRecords: "Share my records",
    stopSharingRecords: "Stop sharing my records",
    writeLetter: "Write Letter",
    writeReferral: "Write Referral",
});

/**
 * Log when the value of the dropdown in 'Add patient to practice' modal changes 
 * @param {number} providerId ID of provider selected in dialog
 */
el8.util.amplitude.logAddPatientToPracticeProviderSelect = function(physicianId) {
    if (el8Globals.FEATURES.PLR4Everyone) {
        try {
            var ampData = {
                'selected provider': physicianId,
            };

            el8.util.amplitude.logEvent('Add Patient to Collaborative Practice View', ampData)
        } catch (err) {
            console.warn(err);
        }
    }
}

/**
 * Log when 'Add patient to practice' is agreed and continued or canceled
 * 
 * @param {Object} data collaborative patients adding to practice dialog
 * @param {string} data.addPatientButton the name of the action item selected
 * @param {number} data.changePhysicianId includes changed provider ID
 */
 el8.util.amplitude.logAddPatientToPractice = function(data) {
    if (el8Globals.FEATURES.PLR4Everyone) {
        try {
            var ampData = {
                action: data.addPatientButton,
                'selected provider': data.changePhysicianId,
            };
            el8.util.amplitude.logEvent('Add Patient to Collaborative Practice', ampData)
        } catch (err) {
            console.warn(err);
        }
    }
}

/**
 * Log when "Update" button is pressed on the clinical profile
 * 
 * @param {boolean} isNewUpdate contains the information if the 'New' badge is showing 
 */
 el8.util.amplitude.logClinicalProfileUpdateButtonPressed = function(isNewUpdate) {
    if (el8Globals.FEATURES.PLR4Everyone) {
        try {
            var ampData = {
                'source': 'clinical profile',
                'new updates': isNewUpdate,  
            };
            el8.util.amplitude.logEvent('Open Compare Clinical Profiles Dialog', ampData);
        } catch (err) {
            console.warn(err);
        }
    }
}

/**
 * Log actions on the clinical profile view
 * 
 * @param {Object} data contains the information if the 'New' badge is showing 
 * @param {string} data.action contains the action the user is taking
 * @param {string} data.comparing_practice contains the comparing practice id
 * @param {string} data.selected_tab optional for when action is select tab, 
 *                                   this contains the selected tab
 */
 el8.util.amplitude.logCompareClinicalProfilefromCareTeam = function(data) {
    if(el8Globals.FEATURES.PLR4Everyone){
        try {
            var ampData = {
                "Action": data.action,  
                "Practice compare to": data.comparing_practice,
                "Selected tab": data.selected_tab,
            };
            el8.util.amplitude.logEvent('Choose Compare Clinical Profiles Action', ampData);
        } catch (err) {
            console.warn(err);
        }
    }
}

/**
 * Log the actions on chronological records header for practices with PLR4everyone
 * 
 * @param {string} action contains the information if the 'New' badge is showing 
 */
 el8.util.amplitude.logPLRChronologicalRecordCollabView = function(action) {
    if(el8Globals.FEATURES.PLR4Everyone)
    {
        try {
            var ampData = {
                "Action": action,  
            };
            el8.util.amplitude.logEvent('Respond to PLR Notification ', ampData);
        } catch (err) {
            console.warn(err);
        }
    }
}

/**
 * Log preview individual items on the chronological records for practices with PLR4everyone
 * 
 * @param {Object} data individual item on chronological records
 * @param {string} data.type the item type user is interacting with
 * @param {string} data.source the item source
 */
el8.util.amplitude.logPLRChronologicalPreviewItem = function(data) {
    if(el8Globals.FEATURES.PLR4Everyone) 
    {
        try {
            var ampData = { 
                "Type": data.type,
                "Source": data.source,
            };
            el8.util.amplitude.logEvent('Preview Collaborative Record Item', ampData);
        } catch (err) {
            console.warn(err);
        }
    }
}

/**
 *  Log when action occur on the Care Team dropdown. The logs are behind the 
 *  feature flag PLR4Everyone
 * 
 * @param {Object} data collaborative data for care team
 * @param {string} data.action contains the action event which occurred
 * @param {string} data.providerId contains the id of the selected provider
 * @param {string} data.source contains the source of event called
 */
el8.util.amplitude.logCareActionForPLRClinics = function(data) {
    if(el8Globals.FEATURES.PLR4Everyone) {
        try {
            var ampData = {
                "Action": data.action,
                "Selected provider": data.providerId,
                "Source": data.source,
            };
            el8.util.amplitude.logEvent('Choose Care Team Action', ampData);
        } catch (err) {
            console.warn(err);
        }
    }
}

/**
 * Log when a Import New occurs by category
 * 
 * @param {Object} data contains the information for the Import New
 * @param {string} data.category contains the section the import is from
 * @param {number} data.number contains the number of new imports
 */
 el8.util.amplitude.logCompareClinicalProfileImportNewByCategory = function(data) {
    if(el8Globals.FEATURES.PLR4Everyone){
        try {
            var ampData = {
                "Category": comparingProfilesSectionsMap[data.category],  
                "Number of imported records": data.number,
            };
            el8.util.amplitude.logEvent('Import New items from clinical category', ampData);
        } catch (err) {
            console.warn(err);
        }
    }
}

/**
 * Log when a Import New occurs by category
 * 
 * @param {string} category contains the section the import is from
 */
 el8.util.amplitude.logCompareClinicalProfileSingleImport = function(category) {
    if (el8Globals.FEATURES.PLR4Everyone) {
        try {
            var ampData = {
                category: comparingProfilesSectionsMap[category],  
            };
            
            el8.util.amplitude.logEvent('Import Single Item from clinical category', ampData);
        } catch (err) {
            console.warn(err);
        }
    }
}

/**
 * Log importing individual items on the chronological records for practices with PLR4everyone
 * 
 * @param {Object} data individual item on chronological records
 * @param {string} data.type the item type user is interacting with
 * @param {string} data.source the item source
 */
 el8.util.amplitude.logPLRChronologicalImportSignItem = function(data) {
    if(el8Globals.FEATURES.PLR4Everyone) 
    {
        try {
            var ampData = { 
                "Type": data.type,
                "Source": data.source,
            };
            el8.util.amplitude.logEvent('Import and Sign collaborative record item', ampData);
        } catch (err) {
            console.warn(err);
        }
    }
}

/**
 * Log importing individual items from preview view on the chronological records for practices 
 * with PLR4everyone
 * 
 * @param {string} data the item type user is interacting with
 */
 el8.util.amplitude.logPLRChronologicalImportFromPreviewItem = function() {
    if(el8Globals.FEATURES.PLR4Everyone) 
    {
        try {
            el8.util.amplitude.logEvent('Sign & Import from Preview of collaborative record item view');
        } catch (err) {
            console.warn(err);
        }
    }
}

/**
 * Log provider is adding a provider and choices whether to add or discard the action.
 * The logs are behind the feature flag PLR4Everyone
 * 
 * @param {Object} data contains the information if provider is added to profile or discarded
 * @param {string} data.action contains the action event which occurred
 * @param {string} data.source contains the source of event called
 */
 el8.util.amplitude.logCareTeamAddToProfile = function(data) {
    if(el8Globals.FEATURES.PLR4Everyone) {   
        try {
            var ampData = {
                "Action": data.action, 
                "Source": data.source,
            };
            el8.util.amplitude.logEvent('Add Provider to Care Team', ampData);
        } catch (err) {
            console.warn(err);
        }
    }
}

/**
 * Log when a Import All occurs by category
 * 
 * @param {Object} data contains the information for the Import All
 * @param {string} data.category contains the section the import is from
 * @param {number} data.number contains the number of new imports
 */
 el8.util.amplitude.logCompareClinicalProfileImportAllByCategory = function(data) {
    if(el8Globals.FEATURES.PLR4Everyone){
        try {
            var ampData = {
                "Category": comparingProfilesSectionsMap[data.category],  
                "Number of imported records": data.number,
            };
            el8.util.amplitude.logEvent('Import All items from clinical category', ampData);
        } catch (err) {
            console.warn(err);
        }
    }
}
